import React, { createContext, useContext, useState, ReactNode } from 'react';

type Language = 'ru' | 'fr' | 'en';

interface Translations {
  [key: string]: {
    [key in Language]: string;
  };
}

const translations: Translations = {
  // Navigation
  'nav.home': {
    ru: 'Главная',
    fr: 'Accueil',
    en: 'Home'
  },
  'nav.services': {
    ru: 'Услуги',
    fr: 'Services',
    en: 'Services'
  },
  'nav.portfolio': {
    ru: 'Портфолио',
    fr: 'Portfolio',
    en: 'Portfolio'
  },
  'nav.team': {
    ru: 'Команда',
    fr: 'Équipe',
    en: 'Team'
  },
  'nav.blog': {
    ru: 'Блог',
    fr: 'Blog',
    en: 'Blog'
  },
  'nav.careers': {
    ru: 'Карьера',
    fr: 'Carrières',
    en: 'Careers'
  },
  'nav.about': {
    ru: 'О нас',
    fr: 'À propos',
    en: 'About'
  },
  'nav.contact': {
    ru: 'Контакты',
    fr: 'Contact',
    en: 'Contact'
  },
  'nav.startProject': {
    ru: 'Начать проект',
    fr: 'Démarrer un projet',
    en: 'Start Project'
  },
  'nav.language': {
    ru: 'Язык',
    fr: 'Langue',
    en: 'Language'
  },

  // Common UI
  'common.viewDetails': {
    ru: 'Подробнее',
    fr: 'Voir détails',
    en: 'View details'
  },
  'common.readMore': {
    ru: 'Читать далее',
    fr: 'Lire la suite',
    en: 'Read more'
  },
  'common.all': {
    ru: 'Все',
    fr: 'Tous',
    en: 'All'
  },
  'common.loading': {
    ru: 'Загрузка...',
    fr: 'Chargement...',
    en: 'Loading...'
  },
  'common.noResults': {
    ru: 'Ничего не найдено',
    fr: 'Aucun résultat',
    en: 'No results'
  },

  // Hero Section
  'hero.title': {
    ru: 'Разрабатываем цифровые решения',
    fr: 'Développons vos solutions numériques',
    en: 'Building Digital Solutions'
  },
  'hero.subtitle': {
    ru: 'ООО DevAlpha - Ваш надежный партнер в веб-разработке и мобильных приложениях в Беларуси и ДРК',
    fr: 'DevAlpha SRL - Votre partenaire de confiance en développement web et mobile au Bélarus et en RDC',
    en: 'DevAlpha LLC - Your trusted partner in web and mobile development in Belarus and DRC'
  },
  'hero.cta': {
    ru: 'Начать проект',
    fr: 'Démarrer un projet',
    en: 'Start a Project'
  },

  // Services
  'services.web': {
    ru: 'Веб-разработка',
    fr: 'Développement Web',
    en: 'Web Development'
  },
  'services.mobile': {
    ru: 'Мобильная разработка',
    fr: 'Développement Mobile',
    en: 'Mobile Development'
  },
  'services.backend': {
    ru: 'Backend и базы данных',
    fr: 'Backend et Bases de Données',
    en: 'Backend & Databases'
  },
  'services.cloud': {
    ru: 'Облачные решения',
    fr: 'Solutions Cloud',
    en: 'Cloud Solutions'
  },

  // About
  'about.description': {
    ru: 'DevAlpha - это команда профессиональных разработчиков, специализирующихся на создании современных веб-приложений и мобильных решений для бизнеса.',
    fr: 'DevAlpha est une équipe de développeurs professionnels spécialisés dans la création d\'applications web modernes et de solutions mobiles pour les entreprises.',
    en: 'DevAlpha is a team of professional developers specializing in creating modern web applications and mobile solutions for businesses.'
  },

  // Contact

  // Footer
  'footer.about': {
    ru: 'О нас',
    fr: 'À propos',
    en: 'About'
  },
  'footer.services': {
    ru: 'Услуги',
    fr: 'Services',
    en: 'Services'
  },
  'footer.portfolio': {
    ru: 'Портфолио',
    fr: 'Portfolio',
    en: 'Portfolio'
  },
  'footer.team': {
    ru: 'Команда',
    fr: 'Équipe',
    en: 'Team'
  },
  'footer.blog': {
    ru: 'Блог',
    fr: 'Blog',
    en: 'Blog'
  },
  'footer.careers': {
    ru: 'Карьера',
    fr: 'Carrières',
    en: 'Careers'
  },
  'footer.contact': {
    ru: 'Контакты',
    fr: 'Contact',
    en: 'Contact'
  },
  'footer.privacy': {
    ru: 'Политика конфиденциальности',
    fr: 'Politique de confidentialité',
    en: 'Privacy Policy'
  },
  'footer.terms': {
    ru: 'Условия использования',
    fr: 'Conditions d\'utilisation',
    en: 'Terms of Service'
  },
  'footer.newsletter': {
    ru: 'Подпишитесь на рассылку',
    fr: 'Newsletter',
    en: 'Newsletter'
  },
  'footer.newsletter.placeholder': {
    ru: 'Ваш email',
    fr: 'Votre email',
    en: 'Your email'
  },
  'footer.newsletter.button': {
    ru: 'Подписаться',
    fr: 'S\'abonner',
    en: 'Subscribe'
  },
  'footer.social': {
    ru: 'Мы в социальных сетях',
    fr: 'Suivez-nous',
    en: 'Follow Us'
  },
  'footer.rights': {
    ru: 'Все права защищены',
    fr: 'Tous droits réservés',
    en: 'All rights reserved'
  },
  'footer.tagline': {
    ru: 'Ваш надёжный партнёр в инновационных и эффективных цифровых решениях.',
    fr: 'Votre partenaire de confiance pour des solutions digitales innovantes et performantes.',
    en: 'Your trusted partner for innovative, high-performance digital solutions.'
  },
  'footer.company': {
    ru: 'Компания',
    fr: 'Entreprise',
    en: 'Company'
  },
  'footer.quickLinks': {
    ru: 'Быстрые ссылки',
    fr: 'Liens Rapides',
    en: 'Quick Links'
  },
  'footer.cookies': {
    ru: 'Файлы cookie',
    fr: 'Cookies',
    en: 'Cookies'
  },

  // Home Page
  'home.hero.title': {
    ru: 'Инновационные цифровые решения',
    fr: 'Solutions Numériques Innovantes',
    en: 'Innovative Digital Solutions'
  },
  'home.hero.subtitle': {
    ru: 'DevAlpha - ваш надежный партнер в мире веб-разработки и мобильных приложений',
    fr: 'DevAlpha - Votre partenaire de confiance en développement web et mobile',
    en: 'DevAlpha - Your trusted partner in web and mobile development'
  },
  'home.hero.cta': {
    ru: 'Начать проект',
    fr: 'Démarrer un projet',
    en: 'Start a Project'
  },
  'home.hero.secondary': {
    ru: 'Наши работы',
    fr: 'Nos réalisations',
    en: 'Our Work'
  },
  'home.services.title': {
    ru: 'Наши услуги',
    fr: 'Nos services',
    en: 'Our Services'
  },
  'home.services.subtitle': {
    ru: 'Комплексные решения для вашего бизнеса',
    fr: 'Solutions complètes pour votre entreprise',
    en: 'Comprehensive solutions for your business'
  },
  'home.portfolio.title': {
    ru: 'Наши проекты',
    fr: 'Nos projets',
    en: 'Our Projects'
  },
  'home.portfolio.subtitle': {
    ru: 'Последние работы',
    fr: 'Réalisations récentes',
    en: 'Recent Work'
  },
  'home.testimonials.title': {
    ru: 'Отзывы клиентов',
    fr: 'Témoignages clients',
    en: 'Client Testimonials'
  },
  'home.testimonials.subtitle': {
    ru: 'Что говорят наши клиенты',
    fr: 'Ce que disent nos clients',
    en: 'What our clients say'
  },
  'home.technologies.title': {
    ru: 'Наши технологии',
    fr: 'Technologies Maîtrisées',
    en: 'Mastered Technologies'
  },
  'home.technologies.subtitle': {
    ru: 'Экспертиза в самых востребованных технологиях',
    fr: 'Expertise de pointe dans les technologies les plus demandées',
    en: 'Cutting-edge expertise in the most in-demand technologies'
  },

  // Services Page
  'services.title': {
    ru: 'Наши услуги',
    fr: 'Nos services',
    en: 'Our Services'
  },
  'services.subtitle': {
    ru: 'Полный спектр услуг по разработке',
    fr: 'Services complets de développement',
    en: 'Full development services'
  },
  'services.description': {
    ru: 'От идеи до запуска — мы сопровождаем вашу цифровую трансформацию.',
    fr: 'De la conception à la livraison, nous vous accompagnons dans votre transformation digitale.',
    en: 'From concept to delivery, we support your digital transformation.'
  },
  'services.web.title': {
    ru: 'Веб-разработка',
    fr: 'Développement Web',
    en: 'Web Development'
  },
  'services.web.description': {
    ru: 'Современные веб-приложения с использованием последних технологий',
    fr: 'Applications web modernes avec les dernières technologies',
    en: 'Modern web applications with latest technologies'
  },
  'services.mobile.title': {
    ru: 'Мобильная разработка',
    fr: 'Développement Mobile',
    en: 'Mobile Development'
  },
  'services.mobile.description': {
    ru: 'Нативные и кроссплатформенные мобильные приложения',
    fr: 'Applications mobiles natives et multiplateformes',
    en: 'Native and cross-platform mobile applications'
  },
  'services.backend.title': {
    ru: 'Backend и базы данных',
    fr: 'Backend et Bases de Données',
    en: 'Backend & Databases'
  },
  'services.backend.description': {
    ru: 'Масштабируемые backend-решения и оптимизированные базы данных',
    fr: 'Solutions backend évolutives et bases de données optimisées',
    en: 'Scalable backend solutions and optimized databases'
  },
  'services.cloud.title': {
    ru: 'Облачные решения',
    fr: 'Solutions Cloud',
    en: 'Cloud Solutions'
  },
  'services.cloud.description': {
    ru: 'Развертывание и управление облачной инфраструктурой',
    fr: 'Déploiement et gestion d\'infrastructure cloud',
    en: 'Cloud infrastructure deployment and management'
  },
  'services.ai.title': {
    ru: 'Искусственный интеллект',
    fr: 'Intelligence Artificielle',
    en: 'Artificial Intelligence'
  },

  // Portfolio Page
  'portfolio.title': {
    ru: 'Портфолио',
    fr: 'Portfolio',
    en: 'Portfolio'
  },
  'portfolio.subtitle': {
    ru: 'Наши лучшие работы',
    fr: 'Nos meilleures réalisations',
    en: 'Our best work'
  },
  'portfolio.description': {
    ru: 'Откройте наши лучшие проекты. Каждый проект демонстрирует наш технический опыт и креативность.',
    fr: 'Découvrez nos réalisations les plus impressionnantes. Chaque projet démontre notre expertise technique et notre créativité.',
    en: 'Discover our most impressive work. Each project showcases our technical expertise and creativity.'
  },
  'portfolio.filter.all': {
    ru: 'Все',
    fr: 'Tous',
    en: 'All'
  },
  'portfolio.filter.web': {
    ru: 'Веб',
    fr: 'Web',
    en: 'Web'
  },
  'portfolio.filter.mobile': {
    ru: 'Мобильные',
    fr: 'Mobile',
    en: 'Mobile'
  },
  'portfolio.filter.design': {
    ru: 'Дизайн',
    fr: 'Design',
    en: 'Design'
  },
  'portfolio.viewProject': {
    ru: 'Смотреть проект',
    fr: 'Voir le projet',
    en: 'View Project'
  },

  // About Page
  'about.title': {
    ru: 'О компании',
    fr: 'À propos',
    en: 'About'
  },
  'about.subtitle': {
    ru: 'Создаем будущее цифровых технологий',
    fr: 'Créons l\'avenir des technologies numériques',
    en: 'Creating the future of digital technology'
  },
  'about.mission': {
    ru: 'Наша миссия',
    fr: 'Notre mission',
    en: 'Our Mission'
  },
  'about.mission.text': {
    ru: 'Мы создаем инновационные решения, которые помогают бизнесу расти и процветать в цифровой эпохе.',
    fr: 'Nous créons des solutions innovantes qui aident les entreprises à croître et prospérer à l\'ère numérique.',
    en: 'We create innovative solutions that help businesses grow and thrive in the digital age.'
  },
  'about.vision': {
    ru: 'Наше видение',
    fr: 'Notre vision',
    en: 'Our Vision'
  },
  'about.vision.text': {
    ru: 'Стать лидером в области разработки цифровых решений, признанным за качество и инновации.',
    fr: 'Devenir leader dans le développement de solutions numériques, reconnu pour la qualité et l\'innovation.',
    en: 'Become a leader in digital solution development, recognized for quality and innovation.'
  },
  'about.values': {
    ru: 'Наши ценности',
    fr: 'Nos valeurs',
    en: 'Our Values'
  },

  // Contact Page
  'contact.title': {
    ru: 'Связаться с нами',
    fr: 'Contactez-nous',
    en: 'Contact Us'
  },
  'contact.subtitle': {
    ru: 'Давайте обсудим ваш проект',
    fr: 'Discutons de votre projet',
    en: 'Let\'s discuss your project'
  },
  'contact.description': {
    ru: 'Готовы воплотить ваши идеи? Наша команда экспертов готова обсудить ваш проект.',
    fr: 'Prêt à transformer vos idées en réalité ? Notre équipe d\'experts est à votre écoute pour discuter de votre projet.',
    en: 'Ready to turn your ideas into reality? Our team of experts is here to discuss your project.'
  },
  'contact.info.title': {
    ru: 'Контактная информация',
    fr: 'Informations de contact',
    en: 'Contact Information'
  },
  'contact.info.email': {
    ru: 'Email',
    fr: 'Email',
    en: 'Email'
  },
  'contact.info.phone': {
    ru: 'Телефон',
    fr: 'Téléphone',
    en: 'Phone'
  },
  'contact.info.address': {
    ru: 'Адрес',
    fr: 'Adresse',
    en: 'Address'
  },
  'contact.form.title': {
    ru: 'Отправить сообщение',
    fr: 'Envoyer un message',
    en: 'Send Message'
  },
  'contact.form.name': {
    ru: 'Имя',
    fr: 'Nom',
    en: 'Name'
  },
  'contact.form.email': {
    ru: 'Email',
    fr: 'Email',
    en: 'Email'
  },
  'contact.form.subject': {
    ru: 'Тема',
    fr: 'Sujet',
    en: 'Subject'
  },
  'contact.form.message': {
    ru: 'Сообщение',
    fr: 'Message',
    en: 'Message'
  },
  'contact.form.submit': {
    ru: 'Отправить',
    fr: 'Envoyer',
    en: 'Send'
  },

  // Team Page
  'team.title': {
    ru: 'Наша команда',
    fr: 'Notre équipe',
    en: 'Our Team'
  },
  'team.subtitle': {
    ru: 'Профессионалы, создающие инновационные решения',
    fr: 'Des professionnels créant des solutions innovantes',
    en: 'Professionals creating innovative solutions'
  },
  'team.role.developer': {
    ru: 'Разработчик',
    fr: 'Développeur',
    en: 'Developer'
  },
  'team.role.designer': {
    ru: 'Дизайнер',
    fr: 'Designer',
    en: 'Designer'
  },
  'team.role.manager': {
    ru: 'Менеджер',
    fr: 'Manager',
    en: 'Manager'
  },

  // Blog Page
  'blog.title': {
    ru: 'Блог',
    fr: 'Blog',
    en: 'Blog'
  },
  'blog.subtitle': {
    ru: 'Последние новости и статьи',
    fr: 'Dernières nouvelles et articles',
    en: 'Latest news and articles'
  },
  'blog.description': {
    ru: 'Статьи, новости и советы о веб-разработке, дизайне и инновациях.',
    fr: 'Articles, actualités et conseils sur le développement web, le design et l\'innovation.',
    en: 'Articles, news and tips about web development, design and innovation.'
  },
  'blog.readMore': {
    ru: 'Читать далее',
    fr: 'Lire la suite',
    en: 'Read More'
  },
  'blog.published': {
    ru: 'Опубликовано',
    fr: 'Publié le',
    en: 'Published'
  },

  // Careers Page
  'careers.title': {
    ru: 'Карьера',
    fr: 'Carrières',
    en: 'Careers'
  },
  'careers.subtitle': {
    ru: 'Присоединяйтесь к команде профессионалов',
    fr: 'Rejoignez une équipe de professionnels',
    en: 'Join a team of professionals'
  },
  'careers.description': {
    ru: 'Мы ищем партнёров, увлечённых инновациями и совершенством.',
    fr: 'Chez DevAlpha, nous cherchons des partenaires passionnés par l\'innovation et l\'excellence.',
    en: 'At DevAlpha, we look for partners passionate about innovation and excellence.'
  },
  'careers.openings': {
    ru: 'Открытые позиции',
    fr: 'Postes ouverts',
    en: 'Open Positions'
  },
  'careers.apply': {
    ru: 'Откликнуться',
    fr: 'Postuler',
    en: 'Apply'
  },

  // Start Project Page
  'startProject.title': {
    ru: 'Начать проект',
    fr: 'Démarrer un projet',
    en: 'Start Project'
  },
  'startProject.subtitle': {
    ru: 'Давайте создадим что-то удивительное вместе',
    fr: 'Créons quelque chose d\'extraordinaire ensemble',
    en: 'Let\'s create something amazing together'
  },
  'startProject.step1': {
    ru: 'Тип проекта',
    fr: 'Type de projet',
    en: 'Project Type'
  },
  'startProject.step2': {
    ru: 'Детали',
    fr: 'Détails',
    en: 'Details'
  },
  'startProject.step3': {
    ru: 'Технологии',
    fr: 'Technologies',
    en: 'Technologies'
  },
  'startProject.step4': {
    ru: 'Файлы',
    fr: 'Fichiers',
    en: 'Files'
  },
  'startProject.step5': {
    ru: 'Сроки и бюджет',
    fr: 'Délai et budget',
    en: 'Timeline & Budget'
  },
  'startProject.step6': {
    ru: 'Контакты',
    fr: 'Coordonnées',
    en: 'Contact'
  },
  'startProject.submit': {
    ru: 'Отправить проект',
    fr: 'Soumettre le projet',
    en: 'Submit Project'
  },

  // Privacy Page
  'privacy.title': {
    ru: 'Политика конфиденциальности',
    fr: 'Politique de confidentialité',
    en: 'Privacy Policy'
  },
  'privacy.subtitle': {
    ru: 'Как мы защищаем ваши данные',
    fr: 'Comment nous protégeons vos données',
    en: 'How we protect your data'
  },

  // Terms Page
  'terms.title': {
    ru: 'Условия использования',
    fr: 'Conditions d\'utilisation',
    en: 'Terms of Service'
  },
  'terms.subtitle': {
    ru: 'Правила использования наших услуг',
    fr: 'Règles d\'utilisation de nos services',
    en: 'Rules for using our services'
  },

  // 404 Page
  'notFound.title': {
    ru: 'Страница не найдена',
    fr: 'Page non trouvée',
    en: 'Page Not Found'
  },
  'notFound.subtitle': {
    ru: 'Страница, которую вы ищете, не существует',
    fr: 'La page que vous cherchez n\'existe pas',
    en: 'The page you\'re looking for doesn\'t exist'
  },
  'notFound.home': {
    ru: 'На главную',
    fr: 'Accueil',
    en: 'Go Home'
  },
  'notFound.back': {
    ru: 'Назад',
    fr: 'Retour',
    en: 'Go Back'
  },
  'notFound.searchHint': {
    ru: 'Или, может быть, вы ищете что-то другое?',
    fr: 'Ou peut-être cherchez-vous quelque chose ?',
    en: 'Or maybe you\'re looking for something?'
  },
  'notFound.searchPlaceholder': {
    ru: 'Поиск...',
    fr: 'Rechercher...',
    en: 'Search...'
  },
  'notFound.refreshHint': {
    ru: 'Попробуйте обновить страницу',
    fr: 'Essayez de rafraîchir la page',
    en: 'Try refreshing the page'
  }
};

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const [language, setLanguageState] = useState<Language>(() => {
    if (typeof window === 'undefined') return 'fr';
    const saved = localStorage.getItem('devalpha_lang') as Language | null;
    return saved === 'fr' || saved === 'en' || saved === 'ru' ? saved : 'fr';
  });

  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    localStorage.setItem('devalpha_lang', lang);
  };

  const t = (key: string): string => {
    return translations[key]?.[language] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
